import { Capacitor } from '@capacitor/core';

export const isNativeApp = () => Capacitor.isNativePlatform();
export const isNativeAndroidApp = () => isNativeApp() && Capacitor.getPlatform() === 'android';

type TAndroidPullToRefreshBridge = {
  setEnabled: (enabled: string) => void;
};

const getAndroidPullToRefreshBridge = (): TAndroidPullToRefreshBridge | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  return (window as Window & { AndroidPullToRefresh?: TAndroidPullToRefreshBridge }).AndroidPullToRefresh;
};

export const setNativePullToRefreshEnabled = (enabled: boolean) => {
  if (!isNativeAndroidApp()) {
    return;
  }

  getAndroidPullToRefreshBridge()?.setEnabled(enabled ? 'true' : 'false');
};
